import { connect } from 'react-redux';
import { SiteLoader } from './SiteLoader';
import { IAppState } from 'types/appState.type';

const mapStateToProps = (state: IAppState): IAppState => {
	return { ...state };
};

export default connect(mapStateToProps)(SiteLoader);
